import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tradingCompetitionKeys } from '../tradingCompetition.keys';
import { getTradingCompetition } from '../tradingCompetition.service';
/**
 * Queries a trading competition by its subdomain
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param enabled Whether the query should be enabled
 * @example const { data, isLoading } = useTradingCompetition('my-community');
 */
export const useTradingCompetition = (subdomain, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tradingCompetitionKeys.tradingCompetition(domain),
        queryFn: async () => getTradingCompetition(domain),
        enabled: isValidSubdomain(domain) && enabled,
        retry: 1,
    });
};
